"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageHeader = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
let PageHeader = class PageHeader extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.description = '';
        this.centered = false;
    }
    render() {
        return (0, lit_1.html) `
      <header>
        <mm-text-block
          heading=${this.heading}
          description=${this.description}
          ?centered=${this.centered}
        ></mm-text-block>
      </header>
    `;
    }
};
PageHeader.styles = (0, lit_1.css) `
    :host {
      display: block;
      padding-bottom: var(--space-8);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PageHeader.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], PageHeader.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean })
], PageHeader.prototype, "centered", void 0);
PageHeader = __decorate([
    (0, decorators_js_1.customElement)('mm-page-header')
], PageHeader);
exports.PageHeader = PageHeader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZS1oZWFkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwYWdlLWhlYWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBRTNELCtCQUE0QjtBQUdyQixJQUFNLFVBQVUsR0FBaEIsTUFBTSxVQUFXLFNBQVEsZ0JBQVU7SUFBbkM7O1FBT3VCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDWixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUNmLGFBQVEsR0FBRyxLQUFLLENBQUE7SUFhL0MsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7b0JBR0ssSUFBSSxDQUFDLE9BQU87d0JBQ1IsSUFBSSxDQUFDLFdBQVc7c0JBQ2xCLElBQUksQ0FBQyxRQUFROzs7S0FHOUIsQ0FBQTtJQUNILENBQUM7O0FBcEJNLGlCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7O0dBS2xCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUFhO0FBQ1o7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOytDQUFpQjtBQUNmO0lBQTVCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsQ0FBQzs0Q0FBaUI7QUFUbEMsVUFBVTtJQUR0QixJQUFBLDZCQUFhLEVBQUMsZ0JBQWdCLENBQUM7R0FDbkIsVUFBVSxDQXNCdEI7QUF0QlksZ0NBQVUifQ==